import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type MarketCustomReportingIndexRoute from 'lumen/routes/market/custom-reporting/index';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketCustomReportingIndexController extends Controller {
  declare model: ModelFrom<MarketCustomReportingIndexRoute>;

  @service declare access: Services['access'];
  @service declare intl: Services['intl'];
  @service declare router: Services['router'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get goToTemplatesBannerAction() {
    return {
      label: this.intl.t('custom_reporting.made_for_you.banner.cta'),
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      action: () => {
        this.router.transitionTo('market.custom-reporting.templates');
      },
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get helpArticles() {
    const articles = [];

    if (this.access.hasCustomReportingEdit) {
      articles.push(
        ...[
          {
            title: this.intl.t('custom_reporting.learn.getting_started.title'),
            description: this.intl.t(
              'custom_reporting.learn.getting_started.description',
            ),
            illustration: '40x40_rocket' as const,
            cta: {
              label: this.intl.t('custom_reporting.learn.getting_started.cta'),
              url: 'http://help.mylighthouse.com/en/articles/9259621-get-started-with-custom-reporting',
            },
          },
          {
            title: this.intl.t(
              'custom_reporting.learn.available_data_to_explore.title',
            ),
            illustration: '40x40_search-chart' as const,
            description: this.intl.t(
              'custom_reporting.learn.available_data_to_explore.description',
            ),
            cta: {
              label: this.intl.t(
                'custom_reporting.learn.available_data_to_explore.cta',
              ),
              url: 'http://help.mylighthouse.com/en/articles/9263294-discover-what-data-is-available-to-you-in-custom-reporting',
            },
          },
        ],
      );
    }

    articles.push(
      ...[
        {
          title: this.intl.t(
            'custom_reporting.learn.scheduling_and_sending.title',
          ),
          illustration: '40x40_scheduling' as const,
          description: this.intl.t(
            'custom_reporting.learn.scheduling_and_sending.description',
          ),
          cta: {
            label: this.intl.t(
              'custom_reporting.learn.scheduling_and_sending.cta',
            ),
            url: 'http://help.mylighthouse.com/en/articles/9230760-scheduling-and-sending-dashboards-in-custom-reporting',
          },
        },
        {
          title: this.intl.t('custom_reporting.learn.exporting_data.title'),
          illustration: '40x40_export-data' as const,
          description: this.intl.t(
            'custom_reporting.learn.exporting_data.description',
          ),
          cta: {
            label: this.intl.t('custom_reporting.learn.exporting_data.cta'),
            url: 'http://help.mylighthouse.com/en/articles/9230757-exporting-data-from-your-custom-reporting',
          },
        },
      ],
    );

    return articles;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get recentlyViewedDashboards() {
    return this.model.recentDashboards.lastSuccessful?.value;
  }
}
